module.exports = {
	"template": "light",
	"template_name": "Light Mark",
	"attributes": {
		"tagline": "A beautiful single-family home that stands out in Deep Ellum’s growing neighborhood",
		"listing_title": "1366 Beverly Avenue",
		"listing_city": "Dallas",
		"listing_state": "TX",
		"listing_postal_code": "75214",
		"listing_price": "250,000",
		"listing_status": "Active",
		"listing_mls_number": "123456",
		"listing_bedroom_count": "5.1",
		"listing_bathroom_count": "6",
		"listing_square_feet": "5,000",
		"listing_lot_square_meters": "12,595",
		"listing_year_built": "1960"
	},
	"steps": [
		{
			"title": "MLS",
			"attributes": [
				{
					"key": "mls_number",
					"type": "listing",
					"title": "MLS",
					"description": "Add the MLS"
				}
			]
		},
		{
			"title": "Cover Image",
			"attributes": [
				{
					"key": "cover_image",
					"type": "listing_images",
					"title": "Listing images",
					"description": "This image should be the best one in the gallery."
				}
			]
		},
		{
			"title": "Text",
			"attributes": [
				{
					"key": "tagline",
					"type": "text",
					"title": "Tagline",
					"description": "Add your tagline"
				}
			]
		},
		{
			"title": "Master Bedroom Image",
			"attributes": [
				{
					"key": "master_bedroom_image",
					"type": "listing_images",
					"title": "Listing images",
					"description": "This image should be a great one from the master bedroom."
				}
			]
		},
		{
			"title": "Detail Image 1",
			"attributes": [
				{
					"key": "detail_image_1",
					"type": "listing_images",
					"title": "Listing images",
					"description": "This image should be a great detail image."
				}
			]
		},
		{
			"title": "Detail Image 2",
			"attributes": [
				{
					"key": "detail_image_2",
					"type": "listing_images",
					"title": "Listing images",
					"description": "This image should be a great detail image."
				}
			]
		},
		{
			"title": "Amenities Section",
			"attributes": [
				{
					"key": "amenities_image",
					"type": "listing_images",
					"title": "Listing images",
					"description": "This image should be a great amenities image."
				},
				{
					"key": "pdf",
					"type": "Media",
					"title": "PDF Download",
					"description": "A document of some of the highlights of this property."
				}
			]
		},
		{
			"title": "Personal Photo",
			"attributes": [
				{
					"key": "personal_image",
					"type": "Media",
					"title": "Personal photo",
					"description": "Requirement: Landscape format (more wide than tall). The cover photo is an extension of you, your brand, and your personality. Cover photo should be clean and balanced with focus on you."
				}
			]
		},
		{
			"title": "Brokerage Info",
			"attributes": [
				{
					"key": "brokerage_logo",
					"type": "Media",
					"title": "Brokerage logo",
					"description": "Brokerage logo."
				},
				{
					"key": "brokerage_title",
					"type": "text",
					"title": "Brokerage title"
				}
			]
		},
		{
			"title": "Website",
			"attributes": [
				{
					"key": "website",
					"type": "text",
					"title": "Website",
					"description": "Add your website URL."
				}
			]
		},
		{
			"title": "Social Links",
			"attributes": [
				{
					"key": "facebook_url",
					"type": "text",
					"title": "Facebook"
				},
				{
					"key": "twitter_url",
					"type": "text",
					"title": "Twitter"
				},
				{
					"key": "instagram_url",
					"type": "text",
					"title": "Instagram"
				},
				{
					"key": "web_url",
					"type": "text",
					"title": "Web"
				}
			]
		},
		{
			"title": "App Links",
			"attributes": [
				{
					"key": "apple_store",
					"type": "text",
					"title": "Apple Store"
				},
				{
					"key": "play_store",
					"type": "text",
					"title": "Play Store"
				}
			]
		}
	]
};


//////////////////
// WEBPACK FOOTER
// ./src/components/Templates/clean/template.json
// module id = 453
// module chunks = 0